import React from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button } from '@mui/material';
import inputTypes from './inputTypes';
import {
  getRoistatFromCookie,
  getUtmFromCookie,
  getYmUidFromCookie,
  getGaUidFromCookie,
  YM_COUNTER_WEBSITE,
} from '../../helpers/utmCookie';
import { getType } from '../../helpers/lib';
import styles from './styles';
import { sendAdvCakePostback } from '../../helpers/advCake';
import { getSubmitFields } from '../../helpers/amoLead';

function FormGenerator({
  fields = [],
  submitHandler,
  buttonLabel = 'отправить',
  wideButton = false,
  type,
  isLoading = false,
  noSubmit = false,
}) {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const generateField = (item) => {
    const { type, name, rules } = item;
    const {
      type: fieldType,
      component,
      attributes,
      validation,
    } = inputTypes[type];

    const FieldComponent = component;

    const currentRules = {
      ...rules,
      ...validation,
    };

    const currentValidation = register(name, currentRules);
    const formFunctions = {
      register,
      setValue,
      setError,
      clearErrors,
      control,
      errors,
    };

    let currentAttributes = { ...attributes };

    if (type === 'howToContact' || type === 'phone') {
      currentAttributes = { ...attributes, formFunctions };
    }

    return (
      <FieldComponent
        {...item}
        type={fieldType || type}
        error={!!errors[name]}
        helperText={errors[name] && errors[name].message}
        {...currentAttributes}
        {...currentValidation}
      />
    );
  };

  const onSubmit = (form) => {
    submitHandler(getSubmitFields(form));
    // sendAdvCakePostback(form);
    // let clientId = '';
    // try {
    //   /*eslint-disable */
    //   clientId = ga && ga.getAll()[0].get('clientId');
    //   /* eslint-enable */
    // } catch (e) {}
    // submitHandler({
    //   ...form,
    //   clientId,
    //   type: getType(type),
    //   roistatVisit: getRoistatFromCookie(),
    //   targetPage: window.location.pathname,
    //   utm: getUtmFromCookie(),
    //   ym_uid: getYmUidFromCookie(),
    //   ga_uid: getGaUidFromCookie(),
    //   ym_counter: YM_COUNTER_WEBSITE,
    // });
  };

  return (
    <Box
      component={noSubmit ? 'div' : 'form'}
      onSubmit={handleSubmit(onSubmit)}
      noValidate
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
      }}
    >
      {fields.map((item) => {
        const { name, type } = item;
        return (
          <Box key={name} sx={styles.field}>
            {generateField(item)}
          </Box>
        );
      })}

      {!noSubmit && (
        <Box sx={styles.submitBlock}>
          <Button
            variant="kitPrimary"
            size="medium"
            type="submit"
            disabled={isLoading}
            sx={styles.submit}
            fullWidth={wideButton}
          >
            {buttonLabel}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default FormGenerator;
